<script setup lang="ts">
import NavItemContent from '@/components/navigation/NavItemContent.vue';
import type { NavItemProps } from '@/types/nav';
import { deepEqual } from 'fast-equals';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const currentRoute = useRoute();
const props = defineProps<NavItemProps>();

const defaultClasses = 'd-flex justify-start ga-2 text-md';

const isActive = computed(() => {
    if (props.routeName === 'module') {
        return currentRoute.name === props.routeName && deepEqual(currentRoute.params, props.routeParams);
    }

    return currentRoute.name === props.routeName;
});
</script>

<template>
    <router-link
        v-if="routeName"
        :class="[{ active: isActive }, defaultClasses, containerClass]"
        :to="{ name: routeName, params: routeParams, replace: routeReplace }"
    >
        <NavItemContent v-bind="props" />
    </router-link>

    <NavItemContent v-else v-bind="props" />
</template>
